import React from 'react';
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const faqs = [
  {
    q: 'How do I place a custom order?',
    a: 'Browse a product, upload required image(s) and/or enter text, add to cart, and checkout. Follow on-screen prompts.'
  },
  {
    q: 'Can I edit my order after placing it?',
    a: 'If production has not started, contact us via the Contact page with your order ID. We will try to accommodate changes.'
  },
  {
    q: 'Do you store my images permanently?',
    a: 'No. All customer-uploaded images are automatically deleted 15 days after order completion.'
  },
  {
    q: 'Do you offer returns or exchanges?',
    a: 'Returns are not accepted. Exchanges are only possible for shipping damage or manufacturing defects with a proper unboxing video.'
  },
  {
    q: 'What payment methods do you support?',
    a: 'Standard online payment options (UPI / cards / wallets) depending on gateway availability.'
  },
  {
    q: 'How long does delivery take?',
    a: 'Production + shipping usually takes 5–10 business days depending on product type and destination.'
  }
];

const FAQ = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h3" gutterBottom fontWeight={700}>FAQ</Typography>
      <Typography variant="subtitle1" color="text.secondary" paragraph>
        Frequently asked questions about ordering, customization, and policies.
      </Typography>
      <Box mt={2}>
        {faqs.map((item, idx) => (
          <Accordion key={idx} disableGutters>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}> 
              <Typography fontWeight={600}>{item.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography color="text.secondary">{item.a}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Container>
  );
};

export default FAQ;
